import { render, staticRenderFns } from "./LayoutRegister.vue?vue&type=template&id=06086ade"
import script from "./LayoutRegister.vue?vue&type=script&lang=js"
export * from "./LayoutRegister.vue?vue&type=script&lang=js"
import style0 from "./LayoutRegister.vue?vue&type=style&index=0&id=06086ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports